// Les pages du carnet de Suzanne.
import type { TextKey } from './fr';
import type { PageId } from '../engine/state';

export const PAGES: Record<PageId, { title: TextKey; text: TextKey }> = {
  premiere_page: { title: 'page.premiere_page.title', text: 'page.premiere_page.text' },
  se_payer_en_premier: { title: 'page.se_payer_en_premier.title', text: 'page.se_payer_en_premier.text' },
  budget: { title: 'page.budget.title', text: 'page.budget.text' },
  fonds_urgence: { title: 'page.fonds_urgence.title', text: 'page.fonds_urgence.text' },
  inflation: { title: 'page.inflation.title', text: 'page.inflation.text' },
  interet_compose: { title: 'page.interet_compose.title', text: 'page.interet_compose.text' },
  capital_humain: { title: 'page.capital_humain.title', text: 'page.capital_humain.text' },
  cout_credit: { title: 'page.cout_credit.title', text: 'page.cout_credit.text' },
  arnaques: { title: 'page.arnaques.title', text: 'page.arnaques.text' },
  train_de_vie: { title: 'page.train_de_vie.title', text: 'page.train_de_vie.text' },
  loin_des_yeux: { title: 'page.loin_des_yeux.title', text: 'page.loin_des_yeux.text' },
  usure: { title: 'page.usure.title', text: 'page.usure.text' },
  acheter_louer: { title: 'page.acheter_louer.title', text: 'page.acheter_louer.text' },
  taux_endettement: { title: 'page.taux_endettement.title', text: 'page.taux_endettement.text' },
  assurance_emprunteur: { title: 'page.assurance_emprunteur.title', text: 'page.assurance_emprunteur.text' },
};
